import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { TemplatePortalDirective } from '@angular/material';
export class TdDataTableTemplateDirective extends TemplatePortalDirective {

   tdDataTableTemplate: string;
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[tdDataTableTemplate]ng-template'}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'tdDataTableTemplate': [{ type: Input },],
};
}

function TdDataTableTemplateDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdDataTableTemplateDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDataTableTemplateDirective.ctorParameters;
/** @type {?} */
TdDataTableTemplateDirective.propDecorators;
/** @type {?} */
TdDataTableTemplateDirective.prototype.tdDataTableTemplate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
